var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"align-center":"","column":""}},[_c('div',[_c('v-icon',{attrs:{"large":""}},[_vm._v("warning")])],1),_c('h4',{staticClass:"display-1"},[_vm._v("Unauthorized")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }